import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  SizedCell,
  SortableHeadCell,
  TextEllipsisWithTooltip,
} from 'components/Kizen/Table';
import { getReportStatusName, getStatusName } from './helpers';
import { EXPORT_IMPORT_SOURCES } from './constants';
import SentMessageModal from 'components/Modals/SentMessage';

const paddingSize = {
  small: '20px',
};
const columnSize = {
  spacer: '20px',
  status: '166px',
};

const StatusCell = ({ value, data }) => {
  const { t } = useTranslation();
  const [emailToShow, setEmailToShow] = useState(null);

  const linkProps = data.report?.email_body
    ? { type: 'link', onClick: () => setEmailToShow(data.report.email_body) }
    : data.failure_report?.url
      ? { type: 'anchor', href: data.failure_report.url }
      : {};
  return (
    <>
      <TextEllipsisWithTooltip {...linkProps}>
        {getReportStatusName(data.report?.report_status, t) ??
          getStatusName(value, t)}
      </TextEllipsisWithTooltip>
      {!!emailToShow && (
        <SentMessageModal
          show
          message={{
            messageType: 'email',
            bodySanitized: emailToShow,
            created: data.completed_at,
            message: data.report?.email_subject,
          }}
          title={t('Import Report: {{fileName}}', {
            fileName: data.imported_file?.name || '',
          })}
          onHide={() => setEmailToShow(null)}
        />
      )}
    </>
  );
};

export const useColumns = (action) => {
  const { t } = useTranslation();

  return useMemo(() => {
    return [
      {
        id: 'spacer-1',
        headCell: <SizedCell width={columnSize.spacer} />,
        cell: <SizedCell width={columnSize.spacer} />,
      },
      {
        id:
          action === EXPORT_IMPORT_SOURCES.EXPORT
            ? 'export_file'
            : 'imported_file',
        headCell: (
          <SortableHeadCell
            label={t('File name')}
            padding={paddingSize.small}
            hasSorting={false}
          />
        ),
        cell: <SizedCell padding={paddingSize.small} />,
        format: (value, data) => (
          <TextEllipsisWithTooltip
            type={value?.url ? 'anchor' : undefined}
            href={value?.url || undefined}
          >
            {value?.name || t('Started {{started_at}}', data)}
          </TextEllipsisWithTooltip>
        ),
      },
      {
        id: 'status',
        headCell: (
          <SortableHeadCell
            label={t('Status')}
            width={columnSize.status}
            padding={paddingSize.small}
            hasSorting={false}
          />
        ),
        cell: (
          <SizedCell width={columnSize.status} padding={paddingSize.small} />
        ),
        format: (value, data) => <StatusCell value={value} data={data} />,
      },
    ];
  }, [action, t]);
};
